module.exports = __webpack_public_path__ + "2d1a49aabe038f0e36cc4d9caa4b8e26.png";